import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { ButtonColor } from '@widgets/eop-button/eop-button.component';
import { InfoBoxType } from '@widgets/info-box/info-box.component';
import { DropdownItem } from '@widgets/dropdown/dropdown-type';
import { FormControl, FormGroup } from '@angular/forms';
import { IconSize, IconWeight } from '@widgets/eop-icon/eop-icon.component';
import { EPricingVisibility } from '@manage/contracts/data/contract.model';
import { TranslateService } from '@ngx-translate/core';

export const NO_TARIFF_VALUE = 'NO_TARIFF';

export interface SelectTariffItem {
  id: string;
  name: string;
  validFrom?: string;
  validTo?: string;
}

export type TariffDropdownValue = SelectTariffItem | typeof NO_TARIFF_VALUE;

export interface TariffAssignmentForm {
  selectedTariff: FormControl<DropdownItem<TariffDropdownValue> | null>;
}

@Component({
  selector: 'eop-select-tariff',
  standalone: false,
  templateUrl: './select-tariff.component.html',
  styleUrl: './select-tariff.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTariffComponent implements OnInit {
  @Input({ required: true }) disableNoTariffValue: boolean;
  @Input({ required: true }) form: FormGroup<TariffAssignmentForm>;
  @Input() loading: boolean = false;
  @Input() showPricingVisibility: boolean = false;
  @Input() disableIfNoItems: boolean = true;

  @Input({ required: true })
  set tariffItems(values: DropdownItem<TariffDropdownValue>[]) {
    if (this.disableNoTariffValue) {
      this.tariffs = values;
    } else {
      this.tariffs = [this.noTariffItem, ...values];
    }
  }

  get tariffItems(): DropdownItem<TariffDropdownValue>[] {
    return this.tariffs;
  }

  get noTariffsAvailable() {
    if (this.disableNoTariffValue) {
      return this.tariffItems.length === 0;
    } else {
      return this.tariffItems.length === 1;
    }
  }

  protected readonly ButtonColor = ButtonColor;
  protected readonly InfoBoxType = InfoBoxType;
  protected readonly IconSize = IconSize;
  protected readonly EPricingVisibility = EPricingVisibility;
  protected readonly IconWeight = IconWeight;

  private readonly translate = inject(TranslateService);

  private tariffs: DropdownItem<TariffDropdownValue>[];
  private readonly noTariffItem: DropdownItem<typeof NO_TARIFF_VALUE> = {
    name: this.translate.instant('EV_DRIVER_ACCOUNT.NO_TARIFF_OPTION'),
    value: NO_TARIFF_VALUE,
  };

  ngOnInit(): void {
    if (!this.disableNoTariffValue && !this.form.controls.selectedTariff.value) {
      this.form.controls.selectedTariff.setValue(this.noTariffItem);
    }
  }
}
